export enum ControleEstoqueLoteStatusEnum {
  Disponivel = 1,
  ProximoVencimento = 2,
  Vencido = 3,
  SemSaldo = 4,
}
